module.exports = __webpack_public_path__ + "static/media/Jane in mahabs.4a05492a.jpg";